export default "__VITE_ASSET__C4KWrIKL__"